import React from 'react';

const activities = [
  {
    title: "Cattle & Cattle Industries",
    image: "/images/cattle.jpeg",
  },
  {
    title: "Milk & Milk Products",
    image: "/images/milk.jpeg",
  },
  {
    title: "Agro-base Industries",
    image: "/images/agro.jpg",
  },
  {
    title: "Rubber Processing Industries",
    image: "/images/rubber.jpeg",
  },
  {
    title: "Industrial Projects",
    image: "/images/industrial.jpg",
  },
  {
    title: "Grape Wines and Alcohol Projects",
    image: "/images/wines.jpeg",
  },
  {
    title: "Projects on fishery",
    image: "/images/fishery.jpeg",
  },
  {
    title: "Projects on Poultry",
    image: "/images/poultry.jpg",
  },
  {
    title: "Projects for Rural Women Development",
    image: "/images/rural-women.jpeg",
  },
  {
    title: "Solar and Renewable Energy",
    image: "/images/solar.jpeg",
  },
  {
    title: "Plastic Processing Industries",
    image: "/images/plastic.jpeg",
  },
  {
    title: "Environmental and waste recycling projects",
    image: "/images/environmental.jpeg",
  },
];

export default function BusinessActivities() {
  return (
    <section className="bg-[#f8f9fa] py-[80px]">
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="text-center mb-[50px] max-w-[800px] mx-auto">
          <h2 className="text-[28px] font-semibold text-[#001d3d] font-display uppercase tracking-wider mb-4 leading-[1.3]">
            Our Business Activities
          </h2>
          <p className="text-[16px] text-[#4a5568] font-body leading-[1.6]">
            Our company has experience in project selection, design, manufacture, supply, erection, and commissioning on a turnkey basis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[30px]">
          {activities.map((activity, index) => (
            <div 
              key={index} 
              className="bg-white rounded-[8px] overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.05)] card-hover transition-transform duration-300 ease-in-out hover:-translate-y-[5px]"
            >
              <div className="relative h-[200px] w-full">
                <img
                  src={activity.image}
                  alt={activity.title}
                  className="w-full h-full object-cover rounded-t-[8px]"
                />
              </div>
              
              <div className="p-[25px] min-h-[110px] flex items-center justify-center text-center">
                <h3 className="text-[18px] font-bold text-[#001d3d] font-display leading-[1.4] uppercase">
                  {activity.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
